import type { SxProps, Theme } from '@mui/material/styles';

type PageBannerIllustrationOptions = {
  compact?: boolean;
};

/**
 * Illustration sizing for horizontal in-app page context banners (header).
 * Keeps large SVG assets visually subordinate to title and description copy.
 */
export const pageBannerIllustrationSx = ({
  compact = false,
}: PageBannerIllustrationOptions = {}): SxProps<Theme> => ({
  display: 'block',
  flexShrink: 0,
  borderRadius: 1.5,
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'action.hover',
  objectFit: 'contain',
  objectPosition: 'center',
  width: { xs: 'auto', md: compact ? 132 : 160 },
  maxWidth: '100%',
  height: 'auto',
  maxHeight: compact ? { xs: 80, md: 92 } : { xs: 100, md: 116 },
  alignSelf: { xs: 'center', md: 'center' },
  mx: { xs: 'auto', md: 0 },
});

/** Illustration sizing for pre-login horizontal hero, pricing teaser, and footer CTA rows. */
export const preLoginHorizontalBannerImageSx: SxProps<Theme> = {
  display: 'block',
  width: '100%',
  maxWidth: { xs: 320, sm: 380, md: 420 },
  maxHeight: { xs: 180, sm: 200, md: 220 },
  height: 'auto',
  mx: 'auto',
  objectFit: 'contain',
  objectPosition: 'center',
};
